// extracted by css-extract-rspack-plugin
export default {"page":"security-report-module__page___Va9zz common-module__contentContainer___BLpMZ","title":"security-report-module__title___tqeX2","form":"security-report-module__form___u2pjt"};